<template>
  <section class="co-bg-striped">
    <div class="co-container-md px-4 py-20 text-center">
      <h3 class="co-display-12 divider mb-5 text-center">
        副業を目指す方にオススメ
      </h3>
      <div class="co-container-sm">
        <TeCommonBannerFirstsidejob />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeCommonBannerFirstsidejob from '~/components/Te/TeCommon/Banner/TeCommonBannerFirstsidejob/TeCommonBannerFirstsidejob.vue'

interface Computed {
  maxBargainPrice: number | '-'
}

interface Props {
  course: any
}

const options = {
  props: {
    course: {
      type: Object,
    },
  },
  filters: {
    addComma(value: number | string) {
      return value.toLocaleString()
    },
  },
  computed: {
    maxBargainPrice() {
      if (this.course) {
        const bargainPriceArray = this.course.attributes.packs.map((p: any) => {
          return p.bargain_price
        })
        if (bargainPriceArray.length !== 0) {
          return bargainPriceArray.reduce((a: any, b: any) => {
            return Math.max(a, b)
          })
        } else {
          return 0
        }
      } else {
        return '-'
      }
    },
  },
  components: {
    TeCommonBannerFirstsidejob,
  }
}

export default defineNuxtComponent(options)
</script>
